export { default } from './ButtonEdge.component';
export * from './ButtonEdge.component';
